import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

import MPage from "../templates/mpage";
import Infobox from "../components/infobox";
import MsjBox from "../components/msjbox";
import GrupoPropuestas from "../components/grupopropuestas";
import Cargando from "../components/cargando";
import ErrorMensaje from "../components/errormensaje";

import useObtenerMunicipio from "../../utils/useObtenerMunicipio";
import useTituloPagina from "../../utils/useTituloPagina";

const MHome = (props) => {
  //Obtengo la información del municipio desde la url.
  const [municipio, error] = useObtenerMunicipio(props.match.params.munUrl);
  useTituloPagina(municipio ? municipio.nombre : null);

  if (error === true)
    return (
      <ErrorMensaje
        titulo="No encontramos este municipio"
        mensaje="Puede que el enlace esté mal escrito o que el municipio no esté disponible."
      />
    );
  if (municipio === undefined) return <Cargando />;

  return (
    <MPage municipio={municipio}>
      <Infobox municipio={municipio} />

      {(municipio.tituloHome || municipio.msjHome) && (
        <MsjBox titulo={municipio.tituloHome} msj={municipio.msjHome} />
      )}

      {(municipio.urlSiguiente || municipio.urlAnterior) && (
        <div className="row m-3">
          <div className="col-12">
            {municipio.urlAnterior && (
              <Link
                to={`/municipio/${municipio.urlAnterior}`}
                className="btn btn-sm ppr-btn-azul font-weight-bold float-left"
              >
                Presupuesto Participativo Anterior
              </Link>
            )}

            {municipio.urlSiguiente && (
              <Link
                to={`/municipio/${municipio.urlSiguiente}`}
                className="btn btn-sm ppr-btn-azul font-weight-bold float-right"
              >
                Presupuesto Participativo Siguiente
              </Link>
            )}
          </div>
        </div>
      )}

      {municipio.etapa === "seleccion" && (
        <GrupoPropuestas
          municipioId={municipio._id}
          munUrl={municipio.nombreUrl}
          estado={"seleccionada"}
          tituloGrupo={"Propuestas Seleccionadas"}
        />
      )}
      <GrupoPropuestas
        municipioId={municipio._id}
        munUrl={municipio.nombreUrl}
        estado={"aceptada"}
        //Una vez terminada la votación, "Aprobadas para Votación" ya no es
        //cierto: pasa a "que participaron de la votación".
        tituloGrupo={
          municipio.etapa === "seleccion"
            ? "Propuestas que participaron de la votación"
            : "Propuestas Aprobadas para Votación"
        }
        //Botón "VOTAR" directo solo mientras la votación pública está abierta.
        permitirVotar={
          municipio.etapa === "votacion" &&
          municipio.tipoVotacion === "publica"
        }
      />
      {/*Las archivadas van detrás de un acordeón para no confundir: no son ni
         las que se votan ni las ganadoras.*/}
      <GrupoPropuestas
        municipioId={municipio._id}
        munUrl={municipio.nombreUrl}
        estado={"archivada"}
        tituloGrupo={"Ver propuestas archivadas"}
        colapsable={true}
      />
    </MPage>
  );
};

export default withRouter(MHome);
